import { hasPermission } from 'store'
import NoAccess from 'components/NoAccess'

// Centralized route guard. Renders children when permitted, else `fallback`

export default function Protected({ permission, allowed, children, fallback = <NoAccess /> }) {
  const ok = allowed
    ? allowed()
    : permission == null
      ? true
      : Array.isArray(permission)
        ? permission.some(hasPermission)
        : hasPermission(permission)

  return ok ? children : fallback
}
